export default function({ store, redirect, route }) {
  if (!store.getters['user/isLoggedIn']) {
    // console.log('user not authenticated')
    return redirect(`/?to=${route.fullPath}`);
  }
}
